import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';

class LatestNews extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL+'/'
    let imagealt = 'image'
    return (
    	<div className="blog-area pd-top-80 pd-bottom-90 go-top">
		  <div className="container">
		    <div className="row justify-content-center">
		      <div className="col-xl-6 col-lg-7">
		        <div className="section-title text-center">
					<ScrollAnimation animateIn="bounceIn">
						<h6 className="sub-title double-line">Latest News</h6>
						<h2 className="title">Our Insights &amp; Articles</h2>
					</ScrollAnimation>
		        </div>
		      </div>
		    </div><br/><br/>
		    <div className="row">
		      <div className="col-lg-4">
		        <ul className="single-blog-list-wrap mb-5 mb-lg-0">
		          <li>
				  	<ScrollAnimation animateIn="fadeInLeft">
		            <div className="media single-blog-list-inner">
		              <div className="media-left date blogcircle">
		                <span>Apr</span><br/>
		                20
		              </div>
		              <div className="media-body details">
		                <ul className="blog-meta">
		                  
		                </ul>
		                <h5><Link to="/">TIPS FOR JEE</Link></h5>
						<p>Know JEE Main Syllabus and Pattern well Say No to distractions Don’t manage Time, manage yourself.</p>
		              </div>
		            </div>
					</ScrollAnimation>
		          </li>
		          <li>
				  	<ScrollAnimation animateIn="fadeInLeft">
		            <div className="media single-blog-list-inner">
		              <div className="media-left date blogcircle">
		                <span>May</span><br/>
		                26
		              </div>
		              <div className="media-body details">
		                <ul className="blog-meta">
		                  
		                </ul>
		                <h5><Link to="/">TIPS FOR NEET EXAM PREPARATION</Link></h5>
						<p>Tips for NEET: 1. You should often set as your top goal to figure out what your teacher wants you to learn.</p>
		              </div>
		            </div>
					</ScrollAnimation>
		          </li>
		          {/* <li>
		            <div className="media single-blog-list-inner">
		              <div className="media-left date">
		                <span>JAN</span><br/>
		                28
		              </div>
		              <div className="media-body details">
		                <ul className="blog-meta">
		                  
		                </ul>
		                <h5><Link to="/">“Dream, dream, dream. Dreams transform into thoughts and thoughts result in Action.”</Link></h5>
		              </div>
		            </div>
		          </li> */}
		        </ul>
		      </div>
		      <div className="col-lg-8">
		        <div className="row justify-content-center">
		          <div className="col-md-6">
				  	<ScrollAnimation animateIn="fadeInUp">
					<div className="single-blog-inner">
						<div className="thumb">
							<img src={publicUrl+"assets/img/website/TIPS-FOR-NRA-CET.png"} alt="img" />
							{/* <span className="date clrWhite">28 JANUARY, 2020</span> */}
						</div>
						<div className="details">
							<ul className="blog-meta">
							
							</ul>
							<h5><Link to="/">TIPS FOR NRA CET</Link></h5>
							<p> Set your own approach which suits you the best and master that. Eventually your own approach will help you in increasing your speed of solving problem.</p>
							{/* <Link className="read-more-text" to="/">READ MORE <i className="fa fa-angle-right" /></Link> */}
						</div>
					</div>
					</ScrollAnimation>
		          </div>
		          <div className="col-md-6">
				  	<ScrollAnimation animateIn="fadeInUp">
						<div className="single-blog-inner">
							<div className="thumb">
								<img src={publicUrl+"assets/img/website/MIET-Group-of-Institutions-&-TMG-College-of-Arts-&-Science.png"} alt="img" />
								{/* <span className="date clrWhite">28 JANUARY, 2020</span> */}
							</div>
							<div className="details">
								<ul className="blog-meta">
								</ul>
								<h5><Link to="/">MIET Group of Institutions & TMG College of Arts & Science </Link></h5>
								<p>TIPS FOR NATA:   Your first and foremost job is to refer the syllabus of the NATA entrance exam and study according to it.</p>
								{/* <Link className="read-more-text" to="/">READ MORE <i className="fa fa-angle-right" /></Link> */}
							</div>
						</div>
					</ScrollAnimation>
		          </div>
		        </div>
		      </div>
		    </div>
		  </div>
		</div>

    )
  }
}

export default LatestNews;
